/*
 * @Description:
 * @Author: Teemo D
 * @Date: 2021-03-23 16:11:05
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-09 14:44:32
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorProfilePage/TopConfigs/Policy/index.tsx
 */

import { DeleteOutlined } from '@ant-design/icons';
import _ from 'lodash';
import React from 'react';
import { useDispatch } from 'react-redux';

import InputSelectAndDelete from '@/src/components/DragRowDisplay/InputSelectAndDelete';
import DragNDropColumns from 'src/components/DragNDropColumns';
import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';
import { randomNumber } from 'src/tools/helper';
import { ActionType } from 'src/types/common/common';
import { validatePolicy } from '../../tools';

import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
// import { EnumLinkType } from 'src/types/common/linkType';

import { EnumCollapseId } from '../../common';
import {
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getPagePolicy,
  getSubmitStamp,
  onCollapseOpen,
  onErrorChange,
  onPolicyChange,
} from '../../slice';

import { errCodesMap } from '@/src/error/code';
import { getI18nFromGeneral } from '@/src/tools/tools';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './css.less';
import { generateNoneLinkData } from 'src/constrains/LinkLibrary/tools';

const Policy = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    data: _data,
    display: _display,
    specificError,
    linkSet,
    isPrimary,
  } = props;

  const _d = useDispatch();

  const defaultLinkTo = generateNoneLinkData();
  const handleSort = (obj) => {
    const { data } = obj;
    _d(
      onPolicyChange({
        type: ActionType.reselect,
        data,
      }),
    );
  };

  const handleInputChange = (value, draggableId) => {
    const dataCopy = _.cloneDeep(_data);
    dataCopy.forEach((item) => {
      if (item.draggableId == draggableId) {
        item.title = value;
      }
    });
    _d(onPolicyChange({ type: ActionType.modify, data: dataCopy }));
  };

  const handleSelectValue = (value, options, data) => {
    const dataCopy = _.cloneDeep(_data);
    dataCopy.forEach((item) => {
      if (item.draggableId == data.draggableId) {
        item.linkTo = value;
      }
    });

    _d(onPolicyChange({ type: ActionType.modify, data: dataCopy }));
  };
  /**
   * 新增policy
   */
  const handleAdd = () => {
    const policyDraggableId = `policy_${randomNumber()}`;
    _d(
      onPolicyChange({
        type: ActionType.add,
        data: {
          draggableId: policyDraggableId,
          title: '',
          linkTo: defaultLinkTo,
        },
      }),
    );
  };
  const handleDelete = (index) => {
    _d(
      onPolicyChange({
        type: ActionType.delete,
        data: index,
      }),
    );
  };

  const rightPart = (index) =>
    _data.length > 1 && isPrimary ? (
      <DeleteOutlined
        rev
        className={css.delete}
        onClick={() => handleDelete(index)}
      />
    ) : (
      ' '
    );
  const childGenerate = (data, index) => {
    const { title, linkTo, draggableId = '' } = data;
    const inputErr =
      _display && (specificError[`${draggableId}titleError`] || []).length > 0;

    const selectError =
      _display &&
      (specificError[`${draggableId}linkTypeError`] || []).length > 0;
    return (
      <InputSelectAndDelete
        hideLink={!isPrimary}
        inputTitle={getI18n('salesChannelContent.index.policyTitle')}
        selectTitle={getI18n('general.link')}
        rightPart={rightPart(index)}
        inputValue={title}
        selectValue={linkTo}
        inputHelp={(specificError[`${draggableId}titleError`] || []).join(' ')}
        inputErr={inputErr}
        selectErr={selectError}
        selectHelp={(specificError[`${draggableId}linkTypeError`] || [])
          .map((err) => (errCodesMap[err] ? errCodesMap[err] : err))
          .join(' ')}
        onSelectChange={(value, option) =>
          handleSelectValue(value, option, data)
        }
        onSetInputValue={(value) => handleInputChange(value, draggableId)}
        linkSet={linkSet}
      />
    );
  };

  return (
    <Section className={css.container} bottomBorder>
      <DragNDropColumns
        disabled={!isPrimary}
        //dragHide={!isPrimary}
        hideTitle
        childGenerate={childGenerate}
        data={_data}
        droppableId={getI18nFromGeneral('general.hOCTitle.policy')}
        onSort={handleSort}
        hideAdd={!isPrimary}
        onAdd={handleAdd}
        addText={`+ ${getI18n('salesChannelContent.index.addNewPolicy')}`}
      />
    </Section>
  );
};

export default ErrorProcessingHOC(Policy, {
  getCollapseOpenStatus,
  onCollapseOpen,
  id: EnumCollapseId.policy,
  getContent: getPagePolicy,
  title: getI18nFromGeneral('general.hOCTitle.policy'),
  getErrorDisplay: getCollapseValidationMsgDisplay,
  onErrorChange,

  validation: (x, _p) => {
    const { isPrimary } = _p;
    return validatePolicy(x, isPrimary);
  },
  getSubmitStamp: getSubmitStamp,
});
